import React, { useState, useEffect } from 'react'
import { Question } from '../../../../Api'
import { getTimeEndingString } from '../../../../Utils/DateTime/dateTimeHelpers'
import { StatusText } from './styles'

type StatusProps = {
  question: Question
}

export const QuestionStatus: React.FC<React.PropsWithChildren<StatusProps>> = ({
  question,
}) => {
  const [statusMsg, setStatusMsg] = useState<string>('')

  useEffect(() => {
    checkStatus()
  }, [])

  useEffect(() => {
    checkStatus()
  }, [question])

  const checkStatus = () => {
    let endingStr = getTimeEndingString(question.closeTime)
    if (!endingStr) return
    if (endingStr === 'past') {
      setStatusMsg('Question is closed.')
      return
    }
    setStatusMsg(`Closes ${endingStr}`)
    return
  }

  return <>{statusMsg && <StatusText>{statusMsg}</StatusText>}</>
}
